import { Component } from "react";

import "./style.scss";

class RoundedBoxInfo extends Component {
    render() {
        return (
            <>
                <div className={`${this.props.className} rounded-box-info`}>{this.props.children}</div>
            </>
        )
    }
}

export default RoundedBoxInfo;